/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


var flktyMerch = new Flickity( '.merch_upsell_slider', {
  // options
  cellAlign: 'left',
  contain: true,
  wrapAround: true,
});
//console.log("flick instance: ", flktyMerch)

var flktyPosts = new Flickity( '.all_posts', {
  cellAlign: 'left',
  contain: true,
  wrapAround: true,
});


(function() {
  // Add custom code below this line

  const logo   = document.querySelector('.fix_section');          
  const target = document.querySelector('.promotion-row__grid'); 
  if (!logo || !target) return;

  const update = () => {
    const stopY   = target.offsetTop + target.offsetHeight / 2;   
    const centreY = window.scrollY + window.innerHeight / 2;      

    if (centreY >= stopY) {                 
      if (!logo.dataset.stuck) {            
        logo.dataset.stuck = '1';
        logo.style.position = 'absolute';
        logo.style.top      = stopY + 'px'; 
      }
    } else {                                
      if (logo.dataset.stuck) {
        logo.dataset.stuck = '';
        logo.style.position = 'fixed';
        logo.style.top      = '50%';        
      }
    }
  };
  
  addEventListener('scroll',  update, { passive: true });
  addEventListener('resize',  update);
  update();      





  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
